import * as React from 'react';
import {useStyles} from '../../../../../hooks/styles';
import {useTheme} from '../../../../../theme';
import {Modal} from '../../../../modal/modal';
import {CityChange} from '../cityChange';
import {Platform} from 'react-native';

const modalHorizontalPadding = 90;
const modalVerticalPadding = 40;

export const CityChangeModal: React.FC<{onClose?: () => void}> = ({onClose}) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    container: {
      paddingTop: modalVerticalPadding,
      paddingBottom: modalVerticalPadding,
      paddingLeft: modalHorizontalPadding,
      paddingRight: modalHorizontalPadding,
      marginBottom: 40,
      position: 'relative',
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    contentContainer: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    closeButton: {
      position: 'absolute',
      padding: 20,
      top: -(modalVerticalPadding + 50),
      right: -(modalHorizontalPadding + 20),
      flexDirection: 'row',
      alignItems: 'center',
    },
    closeButtonText: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.whiteTextColor,
    },
  }));

  return (
    <Modal wrapStyle={styles.container} contentStyle={styles.contentContainer} onClose={onClose}>
      <CityChange onClose={onClose} />
    </Modal>
  );
};
